import React, { ChangeEvent, Component } from 'react';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../FormicaSearchSelectBox';
import FormicaInput from '../FormicaInput';
import { CustomFilterField, CustomFilterLiteralSearch } from '../../../domain/ui/FilterDomains';
import LanguageUtil from 'util/LanguageUtil';

class CustomFilterNumericLiteralComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const { field } = this.props;
    const { value, comparison, comparisonIcon } = this.state;
    const emptyMeansNone = field.emptyMeansNone === true;
    return (
      <div className={'flex flex-col items-start justify-center h-auto max-h-44 w-[420px]'}>
        <div className={'flex flex-col gap-y-1 border-b border-b-[#E0E4E8] items-start gap-x-3 justify-start w-full px-3 py-3'}>
          <div className={'flex flex-col justify-center w-full items-start gap-y-1'}>
            <p className={'text-sm text-f-black-2'}>Comparison</p>
            <span className={'min-w-[120px] w-full '}>
              <FormicaSearchSelectBox
                icon={comparisonIcon}
                value={comparison}
                rounded
                placeholder={LanguageUtil.get({ id: 'common.input.placeholder.comparison', defaultMessage: 'Comparison' })}
                options={this.getComparisonOptions()}
                onChange={this.onChangeComparison}
              />
            </span>
          </div>
          <div className={'flex flex-col justify-center items-start w-full gap-y-1'}>
            <p className={'text-sm text-f-black-2'}>Number</p>
            <FormicaInput
              type={'number'}
              onChange={this.onChangeValue}
              value={value ?? ''}
              placeholder={
                emptyMeansNone
                  ? LanguageUtil.get({ id: 'common.label.none', defaultMessage: 'None' })
                  : undefined
              }
            />
          </div>
        </div>
        <div className={'flex px-2 py-3 bg-main-gray w-full items-center justify-end'}>
          <button
            onClick={this.applyFilter}
            className={'flex items-center justify-center text-sm cursor-pointer w-full h-9 rounded bg-f-purple text-white'}
            disabled={comparison == undefined}
          >
            Apply
          </button>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const { field } = this.props;
    const { value, operator } = field.search.value as CustomFilterLiteralSearch;
    const numericValue =
      value === '' || value === undefined || value === null ? undefined : Number(value);
    const selected = this.getComparisonOptions().find((option) => option.value === operator);
    this.setState({
      value: Number.isNaN(numericValue as number) ? undefined : numericValue,
      comparison: operator,
      comparisonIcon: selected?.icon,
    });
  }

  private getComparisonOptions = (): FormicaSelectBoxItem[] => {
    return [
      { label: 'Equal', value: 'eq', icon: 'equal' },
      { label: 'Not Equal', value: 'neq', icon: 'not-equal' },
      { label: 'Greater Than', value: 'gt', icon: 'greater-than' },
      { label: 'Greater Than Or Equals', value: 'gte', icon: 'greater-than-or-equals' },
      { label: 'Less Than', value: 'lt', icon: 'less-than' },
      { label: 'Less Than Or Equals', value: 'lte', icon: 'less-than-or-equals' },
    ] as FormicaSelectBoxItem[];
  };

  private onChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    this.setState({ value: value === '' ? undefined : Number(value) });
  };

  private onChangeComparison = (event: FormicaSelectBoxItem) => {
    this.setState({ comparison: event.value, comparisonIcon: event.icon });
  };

  private applyFilter = () => {
    const { comparison, value } = this.state;
    const { onChange, field, onApply } = this.props;
    const emptyMeansNone = field.emptyMeansNone === true;
    if (emptyMeansNone) {
      (field.search.value as CustomFilterLiteralSearch).value =
        value === undefined || value === null || Number.isNaN(value) ? '' : value;
    } else {
      (field.search.value as CustomFilterLiteralSearch).value = value || 0;
    }
    (field.search.value as CustomFilterLiteralSearch).operator = comparison || '';
    onChange();
    onApply();
  };
}

interface Props {
  field: CustomFilterField;
  onChange: VoidFunction;
  onApply: () => void;
}

class State {
  value: number | undefined = undefined;
  comparison: string | undefined = 'eq';
  comparisonIcon: string | undefined = 'equal';
}

export default CustomFilterNumericLiteralComponent;
